import * as localStorage from "localforage";

localStorage.config({
  name: "hbdb",
  storeName: "hbstore",
  version: 3,
});

export enum StorageKey {
  AccessToken = "hb.accessToken",
  AccountState = "hb.accountState",
  LastReleaseNotesVersion = "hb.lastReleaseNotesVersion",
  StaySignedIn = "hb.staySignedIn",
}

export function getItem<T>(key: StorageKey): Promise<T>;
export function getItem<T>(key: string): Promise<T | null> {
  return localStorage.getItem<T>(key);
}

export function setItem(key: StorageKey, value: any): Promise<any>;
export function setItem(key: string, value: any): Promise<any> {
  return localStorage.setItem(key, value);
}

export function deleteItem(key: StorageKey): Promise<void>;
export function deleteItem(key: string): Promise<void> {
  return localStorage.removeItem(key);
}
